<template>
  <a-form-model ref="orgForm" :labelCol="{ span: 8 }" :wrapperCol="{ span: 8 }" :model="form" :rules="rules">
    <a-form-model-item label="机构名称" prop="name" class="fix">
      <a-input @change="nameBlur" v-model="form.name" :maxLength="30" placeholder="请输入机构名称">
        <span slot="suffix" title="Extra information"> {{ String(form.name).length }}/30</span>
      </a-input>
    </a-form-model-item>
    <a-form-model-item label="机构类型" required style="margin-bottom: 0">
      <a-row type="flex">
        <a-form-model-item prop="orgType" :wrapperCol="{ span: 22 }" style="flex: 1">
          <a-select :disabled="isDisByType" :options="orgOptions" v-model="form.orgType" @change="changeOrgType" placeholder="请选择机构类型">
            <!-- <a-select-option :value="0">官方自营</a-select-option>
            <a-select-option :value="1">学校</a-select-option>
            <a-select-option :value="2">机构</a-select-option> -->
            <!-- <a-select-option :value="3" :disabled="form.property===0">第三方平台</a-select-option> -->
            <!-- <a-select-option :value="6">脑智家游</a-select-option> -->
            <!-- <a-select-option :value="7">直销机构</a-select-option> -->
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="" prop="property" :wrapperCol="{ span: 22 }" style="flex: 1">
          <a-select
            v-model="form.property"
            :disabled="form.hasSubOrganization"
            optionFilterProp="title"
            @change="(id) => $emit('changeDetail', { property: id })"
            :getPopupContainer="(triggerNode) => triggerNode.parentNode"
            placeholder="请选择机构类型"
          >
            <a-select-option :value="0" title="管理机构">管理机构 </a-select-option>
            <a-select-option :value="1" title="子机构"> 子机构</a-select-option>
          </a-select>
        </a-form-model-item>
      </a-row>
    </a-form-model-item>
    <a-form-model-item v-if="[2, 0, 3].includes(form.orgType)" prop="businessType" label="机构业务属性">
      <a-select :disabled="form.id && [2, 0, 3].includes(sourceDetail.orgType)" v-model="form.businessType" @change="businessTypeChange" optionFilterProp="title" placeholder="请选择机构业务属性">
        <a-select-option :value="1" title="C端业务">C端业务 </a-select-option>
        <a-select-option :value="0" title="B端业务"> B端业务</a-select-option>
      </a-select>
    </a-form-model-item>
    <a-form-model-item label="机构地址" prop="addressList">
      <div class="cascader">
        <a-cascader
          ref="formAddress"
          :options="addressOptions"
          :load-data="addressLoadData"
          v-model="form.addressList"
          @change="addressChange"
          placeholder="请选择机构所在区域"
          change-on-select
          allowClear
        />
        <a-tooltip>
          <template v-if="isAddress" slot="title"> {{ form.province || '' }}{{ form.city ? '/' + form.city : '' }}{{ form.district ? '/' + form.district : '' }}</template>
          <div class="address-value" :class="{ 'c-b3': !isAddress }" @click="$refs['formAddress'].sPopupVisible = true">
            {{ form.province || '' }}{{ form.city ? '/' + form.city : '' }}{{ form.district ? '/' + form.district : '' }}{{ !isAddress ? '请选择机构地址' : '' }}
          </div>
        </a-tooltip>
      </div>
    </a-form-model-item>
    <a-form-model-item label="详细地址" class="fix">
      <a-input v-model="form.address" placeholder="请输入机构详细地址" :maxLength="50">
        <span slot="suffix" title="Extra information"> {{ String(form.address).length }}/50</span>
      </a-input>
    </a-form-model-item>
    <a-form-model-item label="负责人" prop="adminIds">
      <a-select v-model="form.adminIds" mode="multiple" optionFilterProp="title" :getPopupContainer="(triggerNode) => triggerNode.parentNode" placeholder="请选择负责人">
        <a-select-option v-for="item in allPrincipal" :value="item.id" :title="item.name" :key="item.id">
          {{ item.name }}
        </a-select-option>
      </a-select>
    </a-form-model-item>
    <!-- <a-form-model-item v-if="!form.superiorId" label="截止日期" prop="uneffectiveDate">
      <a-date-picker :disabled="form.superiorId ? true : false" :showToday="false" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD" v-model="form.uneffectiveDate" style="width: 100%" />
    </a-form-model-item> -->
    <!-- <a-form-model-item label="分配角色">
      <a-select v-model="form.roleIds" mode="multiple" :getPopupContainer="(triggerNode) => triggerNode.parentNode" placeholder="请分配角色">
        <a-select-option v-for="item in roleOptions" :value="item.id" :key="item.id">{{ item.name }} </a-select-option>
      </a-select>
    </a-form-model-item> -->
    <a-form-model-item label="测试机构">
      <a-radio-group v-model="form.informal" :disabled="!!form.superiorId">
        <a-radio :value="true">是</a-radio>
        <a-radio :value="false">否</a-radio>
      </a-radio-group>
    </a-form-model-item>
    <a-form-model-item label="机构状态">
      <a-radio-group v-model="form.enabled">
        <a-radio :value="false">禁用</a-radio>
        <a-radio :value="true">启用</a-radio>
      </a-radio-group>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import SelectTree from '@/components/SelectTree'
import { findByKey } from '@/utils/util'
export default {
  name: 'OrganizationForm',
  components: { SelectTree },
  props: {
    title: String,
    orgId: [String, Number],
    detail: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    isAddress() {
      return !!(this.form.province || this.form.city || this.form.district)
    },
    isDisByType() {
      return [2, 0, 3].includes(this.sourceDetail.orgType) && !!this.sourceDetail.id
    },
  },
  activated() {
    if (this.orgId) {
      this.$emit('getDetail', this.orgId)
    }
  },
  data() {
    return {
      orgOptions: [
        {
          value: 0,
          title: '官方自营',
          disabled: false,
        },
        {
          value: 1,
          title: '学校',
          disabled: false,
        },
        {
          value: 2,
          title: '机构',
          disabled: false,
        },
      ],
      addressSelectList: [],
      sourceDetail: {},
      rules: {
        property: [{ required: true, message: '请选择机构类型', trigger: 'change' }],
        name: [
          { required: true, message: '请输入机构名称', trigger: 'blur' },
          { min: 2, max: 35, message: '机构名称长度 2 到 35 个字符', trigger: 'blur' },
        ],
        address: [
          { required: true, message: '请输入联系地址', trigger: 'blur' },
          { min: 2, max: 50, message: '联系地址长度 2 到 50 个字符', trigger: 'blur' },
        ],
        addressList: [{ type: 'array', len: 3, required: true, message: '请选择机构地址', trigger: 'change' }],
        orgType: [{ required: true, message: '请选择机构类型', trigger: 'blur' }],
        uneffectiveDate: [{ required: true, message: '请选择截止日期', trigger: 'change' }],
        adminIds: [{ type: 'array', required: true, message: '请选择负责人', trigger: 'blur' }],
        businessType: [{ required: true, message: '请选择业务属性', trigger: 'change' }],
        period: [{ required: true, message: '请选择业务属性', trigger: 'change' }],
      },
      form: {
        businessType: undefined,
        informal: false,
        operatorId: this.$store.getters['account/user'].id,
        id: undefined,
        name: '',
        superiorId: undefined,
        orgType: undefined,
        property: 0,
        province: '',
        city: '',
        district: '',
        provinceId: undefined,
        cityId: undefined,
        districtId: undefined,
        address: '',
        adminIds: [],
        roleIds: [],
        uneffectiveDate: undefined,
        enabled: true,
        addressList: [1, 2],
        courseUsageType: 1,
        period: undefined,
      },
      treeData: [],
      //地址
      addressOptions: [],
      //平台所有用户
      allPrincipal: [],
      //机构角色
      roleOptions: [],
    }
  },
  mounted() {
    const entries = Object.entries(this.$refs.orgForm)
    for (const [key, value] of entries) {
      if (!(key.includes('_') || key.includes('$')) && typeof value === 'function') {
        this[key] = value
      }
    }
    this.getAllPrincipa()
    this.getAddressList()
    this.getRoleOptions()
    this.getTreeData()
  },
  methods: {
    initOrgOptions() {
      const { superiorOrgType, superiorId, orgType } = this.detail
      const [org1, org2, org3] = this.orgOptions
      if (superiorId) {
        if (superiorOrgType == 1) {
          org1.disabled = true
          org3.disabled = true
        }
        if (superiorOrgType == 2) {
          org1.disabled = true
        }
      } else {
        if (orgType == 1) {
          org1.disabled = true
        }
      }

      console.log(this.orgOptions, this.detail, '--this.orgOptions')

      this.$set(this, 'orgOptions', this.orgOptions)
    },
    changeOrgType(id) {
      this.$emit('changeDetail', { orgType: id })
      // this.form.property = undefined
    },
    changeDetail(id) {
      const { informal } = findByKey(this.treeData, id, { key: 'id', children: 'children' }) || {}
      if (informal !== undefined) {
        this.form.informal = informal
      }
      this.$emit('changeDetail', { superiorId: id })
    },
    setting() {
      if (this.form.name) {
        this.nameBlur(this.form.name)
      }
      if (this.form.province) {
        setTimeout(() => {
          const addressList = [this.form.province, this.form.city, this.form.district]
          // this.$refs.formAddress.$el.querySelector("input").value = addressList.filter(f => !!f).join(" / ");
          if (this.$refs.formAddress.$el.querySelector('.ant-cascader-picker-label').firstChild) {
            this.$refs.formAddress.$el.querySelector('.ant-cascader-picker-label').firstChild.data = addressList.filter((f) => !!f).join(' / ')
          }
          this.$nextTick(() => {
            this.form.addressList = [this.form.provinceId + ',' + this.form.province, this.form.cityId + ',' + this.form.city, this.form.districtId + ',' + this.form.district]
          })
          if (this.form.superiorId) {
            const { informal } = findByKey(this.treeData, this.form.superiorId, { key: 'id', children: 'children' }) || {}
            if (informal !== undefined) {
              this.form.informal = informal
            }
          }
          this.form = { ...this.form }
          this.sourceDetail = JSON.parse(JSON.stringify(this.form))
          this.initOrgOptions()
        }, 200)
      }
    },
    //获取所有平台用户
    getAllPrincipa() {
      this.$http.CommonInterface.getAllPrincipal().then((res) => {
        const { data } = res
        this.allPrincipal = data
      })
    },
    // 获取角色
    getRoleOptions(id) {
      let params = {
        // organizationId: this.id,
        roleType: 2, //1:平台角色，2:机构角色
      }
      this.$http.Mechanism.GetRoleOptions(params).then((res) => {
        const { data } = res
        this.roleOptions = data
      })
    },
    /**
     * 获取地址
     * @param id 查询的省市区
     */
    getAddressList(id) {
      return new Promise((resolve, reject) => {
        this.$http.Mechanism.address({ parentId: id || 0 }).then((res) => {
          const { data } = res
          if (id) {
            resolve(
              data.map((v) => {
                return {
                  id: v.id,
                  value: v.id + ',' + v.name,
                  label: v.name,
                  isLeaf: v.level === 4,
                  loading: false,
                }
              })
            )
          } else {
            this.addressOptions = data.map((v) => {
              return {
                id: v.id,
                value: v.id + ',' + v.name,
                label: v.name,
                isLeaf: false,
                loading: false,
              }
            })
          }
        })
      })
    },
    addressLoadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1]
      targetOption.loading = true
      return this.getAddressList(targetOption.value.split(',')[0]).then((data) => {
        targetOption.loading = false
        targetOption.children = data
        this.addressOptions = [...this.addressOptions]
        return data
      })
    },
    addressChange(value) {
      this.form.province = undefined
      this.form.provinceId = undefined
      this.form.city = undefined
      this.form.cityId = undefined
      this.form.district = undefined
      this.form.districtId = undefined
      console.log(this.$refs['formAddress'])

      if (value[0]) {
        this.form.provinceId = value[0].split(',')[0]
        this.form.province = value[0].split(',')[1]
      }

      if (value[1]) {
        this.form.cityId = value[1].split(',')[0]
        this.form.city = value[1].split(',')[1]
      }

      if (value[2]) {
        this.form.districtId = value[2].split(',')[0]
        this.form.district = value[2].split(',')[1]
      }
    },
    businessTypeChange(val) {
      this.$emit('changeDetail', { businessType: val, courseUsageType: this.form.courseUsageType })
    },
    //添加或编辑机构名称时判断是否和已有的机构名称重复，重复项上级机构树为disabled
    nameBlur(e) {
      const value = typeof e === 'string' ? e : e.target.value
      this.form.name = value.replace(/\s*/g, '')

      function disabledData(arr, str) {
        arr.forEach((v) => {
          v.disabled = v.title === str
          if (v.children && v.children.length) {
            return disabledData(v.children, str)
          }
        })
      }

      if (value) {
        disabledData(this.treeData, value)
      }
    },
    //获取上级机构
    getTreeData() {
      let params = {
        type: 5,
        // organizationId: this.orgId,
        organizationId: this.orgId ? this.orgId : undefined,
      }
      this.$http.Mechanism.getSuperiorTree(params).then((res) => {
        const { data } = res
        this.treeData = data
      })
    },

    resetForm() {
      this.$refs.orgForm.resetFields()
      this.form = {
        businessType: undefined,
        operatorId: this.$store.getters['account/user'].id,
        property: 0,
        id: undefined,
        name: '',
        superiorId: undefined,
        orgType: undefined,
        province: '',
        city: '',
        district: '',
        provinceId: undefined,
        cityId: undefined,
        districtId: undefined,
        address: '',
        adminIds: [],
        roleIds: [],
        uneffectiveDate: undefined,
        enabled: true,
        addressList: [1, 2],
        courseUsageType: 1,
      }
    },
  },
}
</script>

<style lang="less" scoped>
.cascader {
  position: relative;
  .address-value {
    position: absolute;
    top: 50%;
    left: 10px;
    transform: translateY(-50%);
    height: 30px;
    line-height: 30px;
    width: 83%;
    background: #fff;
    // pointer-events: none;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.c-b3 {
  color: #bfbfbf;
}
.fix {
  ::v-deep .ant-input {
    padding-right: 50px;
  }
}
</style>
